<template>
  <form @submit.prevent="submit()">
    <div>
      <h4>
        {{ spravka.FIO }}, {{spravka.Address}}
      </h4>
      <input type="hidden" name="label" value="@ViewBag.label" />

      <input type="hidden" name="typ" id="typ" value="1" />
    </div>
    <input type="hidden" name="repos" value="@ViewBag.repos" />
    <div class="row">
      <div class="col-6">
        <div class="mb-3">

          
          <label class="form-label" for="data">Сана</label>
          <input class="form-control" v-model="data" type="date" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="raqam">Рақам</label>
          <input class="form-control" v-model="raqam" type="number" />
        </div>

        <ul class="nav nav-pills" id="myTab" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              @click="sety(1)"
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
              >Оддӣ</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              @click="sety(2)"
              id="profile-tab"
              data-toggle="tab"
              href="#profile"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              >Аҳли хонавода</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="mb-3">
              <label class="form-label" for="memo">Матн</label>
              <textarea
                class="form-control"
                style="height: 200px"
                name="memo1"
                v-model="memo1"
              >
              </textarea>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div class="mb-3">
              <label class="form-label" for="memo">Матн</label>
              <textarea
                class="form-control"
                style="height: 200px"
                v-model="memo2"
              >
              </textarea>
            </div>

            <div class="mb-3">
              <label class="form-label" for="memo">Матн</label>
              <table style="width: 100%" class="table-bordered">
                <thead>
                  <tr>
                    <th>Ному насаб</th>
                    <th minwidth="50px">Муносибат</th>
                    <th style="width: 30px">Соли таваллуд</th>
                    <th minwidth="100px">Эзоҳ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="m in spravka.Members" :key="m">
                    <th> {{ m.Name }}</th>
                    <th>
                      <select v-model.number="m.Rel" class="form-control-sm w-100">
                        <option value=0></option>
                        <option value=1>Сардори хоҷагӣ</option>
                        <option value=2>зан / шавҳар</option>
                        <option value=3>писар / духтар</option>
                        <option value=4>падар / модар</option>
                        <option value=5>келин / домод</option>
                        <option value=6>набера</option>
                        <option value=7>бародар / хоҳар</option>
                        <option value=8>дигар хешовандон</option>
                        <option value=9>хеш не</option>
                      </select>
                    </th>
                    <th>
                      {{ m.Sol }}
                    </th>
                    <th>
                      <input
                        class="form-control-sm w-100"
                        v-model="m.Comment"
                      />
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label" for="joi">Ҷои пешниҳод</label>
          <input class="form-control" v-model="job" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="name1">Шахси иловагии 1</label>
          <input class="form-label" type="checkbox" v-model="name1" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="name2">Шахси иловагии 2 </label>
          <input class="form-label" type="checkbox" v-model="name2" />
        </div>

        <input class="btn btn-primary" type="submit" value="Ok" />
      </div>

      <div class="col-6">


        <div ref="viewer" style="position: absolute;  " ></div>
      </div>
    </div>
  </form>
</template>


<script>
export default {
  data() {
    return {
      typ: 1,
      label: "Метка",
      name1: false,
      name2: false,
      job: "ҷои талабкардашуда",
      data: "",
      raqam: 1,
      memo1: "memo 1",
      memo2: "memo 2",

      member: {},

      //members: [{ Name: "Sattorov", Rel: 1, Sol: 1998, Comment: "werwerwer" }],

      spravka:{},


    param:{
      typ:1,
        memo:"",
        mems:[],
        raqam:0,
        job:"",
        name1:false,
        name2:false,
        data:""

    }

    };
  },

  methods: {
    submit() {
      this.createrep();
    },

    sety(v) {
      this.typ = v;
    },

    async fetchMembers() {
      console.log("start2", this.$store.state.household.ID);

      this.$store.state.members = "";
      console.log("before fetch", this.$store.state.members);
      await this.$api(
        "/api/data/3/" + this.$store.state.household.ID
      )
       // .then((res) => res.json())
        .then((data) => (this.members = data))
        .catch((error) => {
          console.error("There was an error!", error);
        });

      for (let index = 0; index < this.members.length; index++) {
        const el = this.members[index];
        el.Birthday = el.Birthday.substring(0, 4);

        console.log(el.ID, this.$store.state.mid);
        if (el.ID == this.$store.state.mid) {
          this.member = el;
          console.log("selected member", this.member);
        }
      }
      console.log("stop2");
      console.log("members", this.members);
    },

        async fetchPrint() {
      console.log("start2", this.$store.state.household.ID);

      this.$store.state.members = "";
      console.log("before fetch", this.$store.state.members);
      await this.$api(
        "/api/data/7/" + this.$store.state.mid
      )
        //.then((res) => res.json())
        .then((data) => (this.spravka = data))
        .catch((error) => {
          console.error("There was an error!", error);
        });

 
      console.log("stop2");
      console.log("members", this.members);
    },



createrep(){


this.param.data=this.data;
this.param.terid=this.$store.state.terid;
this.param.name1 =this.name1;
this.param.name2 =this.name2;
this.param.mems =this.spravka.Members;
this.param.raqam =this.raqam;
this.param.job =this.job;
this.param.typ =this.typ;

if (this.typ==1)
{
  this.param.memo =this.memo1;
}
else
{
  this.param.memo =this.memo2;
}

var p=JSON.stringify(this.param);

    const reportUrl = ko.observable("Report#"+p);
        const viewerRef = this.$refs.viewer;
        const requestOptions = {
            host: this.$store.state.server+"/",
            invokeAction: "DXXRDV"
        };
        const viewer = new DxReportViewer(viewerRef, { reportUrl, requestOptions });
    viewer.render();
}


  },

  async mounted() {
    if (this.$store.state.mid > 0) {
      console.log("Object", this.$store.state.household.ID);
      console.log("this.$store.state.mid", this.$store.state.mid);
      await this.fetchPrint();
      console.log("fethed");
    }

    console.log("asdasd", this.spravka);

    this.memo1 = this.$store.state.memo1
      .replace("{0}", this.spravka.FIO)
      .replace("{1}", this.spravka.Sol)
      .replace("{2}", this.spravka.Address)
      .replace("{3}", this.spravka.Account);


    this.memo2 = this.$store.state.memo2.replace("{0}", this.spravka.FIO)
      .replace("{1}", this.spravka.Sol)
      .replace("{2}", this.spravka.Address)
      .replace("{3}", this.spravka.Account);


this.data=new Date().getFullYear()+"-0"+new Date().getMonth()+"-"+new Date().getDate();
    
  },

      beforeUnmount() {
        console
        ko.cleanNode(this.$refs.viewer);
    }
    };











//import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";

    import 'devexpress-reporting/dx-webdocumentviewer';
    import { DxReportViewer } from 'devexpress-reporting/dx-webdocumentviewer';
    import * as ko from 'knockout';
 

 

</script>

